import http from '@/utils/http';

export default {
  current: data => http({ url: '/api/admin/v1/settlementMethodConfig/current', data }).then(r => r),
  list: data => http({ url: '/api/admin/v1/settlementMethodConfig/list', data }).then(r => r),
  save: data => http({ url: '/api/admin/v1/settlementMethodConfig/save', data, tip: true }).then(r => r),
};
